import type { GdprFeatureConfig } from './type';

export const gdpr: Partial<GdprFeatureConfig> = {
    dataConsentsAcceptHeader:
        'application/vnd.at.sitsolutions.services.pms.profile.representation.data.consent+json',
    uniqueDocument: true,
};
